// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_75-3";
export var contentContainer = "_75-0";
export var editorContainer = "_75-1";
export var quillInputForm = "_75-2";
export var zoneDivider = "_75-4";